import { useMutation, useQueryClient } from "react-query";
import { Put } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";
import { Order } from "../../types/api/Order";

interface AddShippingName {
  provider: string;
  service_level_token: string;
}

export default (orgId: string, buyerOrgId: string, orderId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  return useMutation<Order, null, AddShippingName>(
    `shipping_${orderId}`,
    async (body: AddShippingName) =>
      Put(
        `/api/shipping/order/${orderId}/rate-type`,
        await getAccessTokenSilently(),
        body
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(`current_cart_${orgId}_${buyerOrgId}`);
        queryClient.invalidateQueries([`add_shipping_name_${orderId}`]);
      },
    }
  );
};
